module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.getPaymentSaldo !== false) ? _c('div', {
    staticClass: "money-info"
  }, [_c('div', {
    staticClass: "money-header-info"
  }, [_vm._v("Twoje środki")]), _vm._v(" "), _c('div', {
    staticClass: "money-amount"
  }, [_c('i', {
    staticClass: "mfind-icon-info"
  }), _vm._v(" " + _vm._s(_vm._f("currency")(_vm.getPaymentSaldo)))])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42e93fbd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/moneyInfo.vue
// module id = 376
// module chunks = 0